const MU = {
  ibanLength: 30,
};
export { MU };
